export default __webpack_public_path__ + "static/media/07_photo.ebf17954.jpg";